import { Button, Typography } from '@mui/material';
import type React from 'react';
import { useEffect, useState } from 'react';
import { BaseModal } from '../common/UI/BaseModal';
import { TenderPermissionsForm } from '../TenderDetails/TenderPermissionsForm';

const EMPTY_ARRAY: never[] = [];

interface ManagePermissionsDialogProps {
  open: boolean;
  onClose: () => void;
  userId: string;
  userName: string;
  currentPermissions: string[];
  onSave: (userId: string, permissions: string[]) => Promise<void>;
}

export const ManagePermissionsDialog: React.FC<ManagePermissionsDialogProps> = ({
  open,
  onClose,
  userId,
  userName,
  currentPermissions,
  onSave,
}) => {
  const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setSelectedPermissions(currentPermissions || EMPTY_ARRAY);
    }
  }, [currentPermissions, open]);

  const handleSave = async () => {
    setSaving(true);
    await onSave(userId, selectedPermissions);
    setSaving(false);
    onClose();
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      title={`Permissions for ${userName}`}
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={saving}>
            Save
          </Button>
        </>
      }
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Grant specific permissions for this tender to override global restrictions.
      </Typography>
      <TenderPermissionsForm permissions={selectedPermissions} onChange={setSelectedPermissions} />
    </BaseModal>
  );
};
